var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import config from './src/config.json';
import { createIntlProvider } from './src/createIntlProvider';
import { TranslationsService } from './src/TranslationsService';
export * from './src/types';
export const initializeTranslationsService = (params) => {
    const { locale, fallbackLocale, fallbackTranslations, TextComponent, project, apiClient } = params, rest = __rest(params, ["locale", "fallbackLocale", "fallbackTranslations", "TextComponent", "project", "apiClient"]);
    const translationsService = new TranslationsService(Object.assign({ locale,
        fallbackLocale,
        fallbackTranslations,
        project }, rest), config, apiClient);
    return {
        translationsService,
        RemoteIntlProvider: createIntlProvider(translationsService, TextComponent),
        setLocale: translationsService.setLocale.bind(translationsService),
    };
};
